import { FileDTO } from './CommonFieldsDTO';
import { ILNEHeroNav } from '../interfaces/ILNEHeroNav';
import { TLNEHeroNav } from '../types/TLNEHeroNav';

export const LNEHeroNavDTO = (data: ILNEHeroNav): TLNEHeroNav => ({
  navHeadline: data.nav_headline,
  navImage: data?.nav_image ? FileDTO(data?.nav_image) : null,
});
